// extracted by mini-css-extract-plugin
export default {"metricsWrapper":"IraUserAssets_metricsWrapper__99UpA"};